import AudioManager from './AudioManager';
import Button from './Button';

const STATE_START = 0;
const STATE_STOP = 1;

/**
 * @class SwitchButton
 * @classdesc A button which has two distinct sprites among which switching
 takes place depending upon user actions
 */
class SwitchButton extends Button {
    /**
     * Creates an instance of SwitchButton.
     * @param {*} path asset name
     * @param {number} [x=0]
     * @param {number} [y=0]
     * @param {*} scale default scale
     * @param {*} clickAction call on click when button in STATE_STOP state
     * @param {*} [closeAction=() => {}] call on click when button in STATE_START state
     */
    constructor(path, x = 0, y = 0, scale, clickAction, closeAction = () => { /* empty */ }) {
        super(path, x, y, scale, clickAction);

        this.closeAction = closeAction;

        this.state = STATE_START;
        this.isMouseOver = false;
    }

    /**
     * handler for click
     * change state to opposite of current state and call appropriate click call action
     */
    onClickHandler() {
        if (this.isDisabled) {
            return;
        }
        if (this.state === STATE_STOP) {
            this.closeAction();
            this.switchState(STATE_START);
        } else if (this.state === STATE_START) {
            this.clickAction();
            this.switchState(STATE_STOP);
        }
        AudioManager.playSound('fx', 'btns');
    }


    /**
     * handler for click in mobile devices
     * change state to opposite of current state and call appropriate click call action
     */
    mobileClickHandler() {
        if (this.state === STATE_STOP) {
            this.switchState(STATE_START);
            this.closeAction();
        } else if (this.state === STATE_START) {
            if (this.isDisabled) {
                return;
            }
            this.switchState(STATE_STOP);
            this.clickAction();
        }
        AudioManager.playSound('fx', 'btns');
    }

    /**
     * to disable button
     */
    disable() {
        this.isDisabled = true;
        this.updateState();
    }

    /**
     *
     * to enable button
     */
    enable() {
        this.isDisabled = false;
        this.updateState();
    }

    /**
     * change button state to provided state
     * @param {*} key change to this state
     */
    switchState(key) {
        if (key === STATE_START) { // 0
            this.state = STATE_START;
        }
        if (key === STATE_STOP) { // 1
            this.state = STATE_STOP;
        }
        this.updateState();
    }

    /**
     * used to display sprite as current state
     */
    updateState() {
        if (this.state === STATE_START) { // 0
            if (this.isDisabled) {
                this.gotoAndStop(2);
            } else if (this.isPointerDown) {
                this.gotoAndStop(3);
            } else if (this.isMouseOver) {
                this.gotoAndStop(1);
            } else {
                this.gotoAndStop(0);
            }
        }
        if (this.state === STATE_STOP) { // 1
            this.gotoAndStop(2);

            // if (this.isDisabled) {
            //     this.gotoAndStop(2);
            // }
            // if (this.isPointerDown) {
            //     this.gotoAndStop(7);
            // } else if (this.isMouseOver) {
            //     this.gotoAndStop(5);
            // } else {
            //     this.gotoAndStop(4);
            // }
        }
    }

    /**
     * Only for desktop devices
     * initialize button with its user interactive events
     */
    _init() {
        setTimeout(() => this.switchState(STATE_START), 100);

        this.on('pointerclick', () => {
            this.onClickHandler();
        });

        this.on('mouseover', () => {
            this.isMouseOver = true;
            this.updateState();
        });

        this.on('mouseout', () => {
            this.isMouseOver = false;
            this.isPointerDown = false;
            this.updateState();
        });

        this.on('pointerdown', () => {
            this.isPointerDown = true;
            this.updateState();
        });

        this.on('pointerup', () => {
            this.isPointerDown = false;
            this.updateState();
        });

        this.on('pointerupoutside', () => {
            this.isPointerDown = false;
            this.updateState();
        });
    }

    /**
     * Only for mobile devices
     * initialize button with its user interactive events
     */
    _initMobile() {
        this.switchState(STATE_START);

        this.on('pointerdown', (e) => {
            if (this.isDisabled) {
                return;
            }
            this.isPointerDown = true;
            this.updateState();
            this.mobileClickHandler();
            e.stopPropagation();
        });

        this.on('pointerupoutside', () => {
            this.isPointerDown = false;
            this.updateState();
        });

        this.on('pointerup', () => {
            this.isPointerDown = false;
            this.updateState();
        });
    }
}

export default SwitchButton;
